module.exports = __webpack_public_path__ + "static/img/opcjpg.042657e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/opcjpg.jpg
// module id = OOh6
// module chunks = 1